import { Badge, Tooltip } from '@chakra-ui/react';
import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { getVisaStatusFormat } from '../../../../../utilities/formatting';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { BadgeWrap } from '../styles';

const VisaStatusFormatter = (cellProps: CellProps) => {
  const value = cellProps.row.visaStatus || 'None';
  if (value === 'None') {
    return (
      <CellEventsHandler cellProps={cellProps}>
        <BadgeWrap>
          <Badge variant={'transparent'}>{value}</Badge>
        </BadgeWrap>
      </CellEventsHandler>
    );
  }

  const visaStatus = getVisaStatusFormat(value);
  return (
    <CellEventsHandler cellProps={cellProps}>
      <Tooltip hasArrow placement="top-end" label={visaStatus.onHoverText}>
        <BadgeWrap>
          <Badge colorScheme={visaStatus.colorScheme}>{value}</Badge>
        </BadgeWrap>
      </Tooltip>
    </CellEventsHandler>
  );
};

export const VisaStatusColumn = (): IColumn => ({
  item: {
    key: 'visaStatus',
    name: 'Visa status',
    width: 'minmax(176px, 1.5fr)',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    formatter: VisaStatusFormatter,
  },
  visible: ({ isVisaStatusVisible }) => isVisaStatusVisible!,
});
